import React from "react";

export const StoreContext = React.createContext();
export const StoreDispatchContext = React.createContext();

function StoreProvider({children}) {
    const [state,setstate] = React.useState(false)
    return(
        <StoreContext.Provider value={state}>
            <StoreDispatchContext.Provider value={setstate} >
                {children}
            </StoreDispatchContext.Provider>
        </StoreContext.Provider>
    )
}

export {StoreProvider};
